module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "uk-width-1-1 uk-width-1-4@m"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-small uk-card-body",
    attrs: {
      "uk-sticky": "offset: 30;bottom: true;media: @m;"
    }
  }, [_c('ul', {
    staticClass: "uk-list uk-list-divider"
  }, _vm._l((_vm.FilterProperties), function(property) {
    return _c('filter-row', _vm._g({
      key: property.id,
      attrs: {
        "property": property,
        "property-values": _vm.FilterPropertyValues[property.id],
        "multiple-mode": _vm.multipleMode,
        "multiple-mode-property": _vm.multipleModeProperty,
        "selected": _vm.selectedPropertyValues[property.id]
      },
      on: {
        "update:multipleMode": function($event) {
          _vm.multipleMode = $event
        },
        "update:multipleModeProperty": function($event) {
          _vm.multipleModeProperty = $event
        }
      }
    }, _vm.$listeners))
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3452fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopGroup/Filters.vue
// module id = 82
// module chunks = 0